(() => {
  const CONFIRMED = 'toasty_confirmed_country_v2';
  const PENDING = 'toasty_pending_country_v2';
  const DISMISSED = 'toasty_destination_dismissed_v2';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  const remove = (storage, key) => { try { window[storage].removeItem(key); } catch {} };
  const init = (root) => {
    if (root.dataset.ready) return;
    const dialog = root.querySelector('dialog');
    const select = root.querySelector('[data-toasty-country-select]');
    const form = root.querySelector('form');
    if (!dialog || !select || !form || !dialog.showModal) return;
    root.dataset.ready = 'true';
    const current = root.dataset.countryCode;
    const valid = (code) => [...select.options].some((option) => option.value === code);
    let touched = false;
    let previousFocus;
    let dismissed = false;
    const explicitRoute = /^\/[a-z]{2}(?:-[a-z]{2})?-[a-z]{2}(?:\/|$)/i.test(location.pathname) || new URLSearchParams(location.search).has('country');
    try {
      const pending = JSON.parse(read('sessionStorage', PENDING) || 'null');
      if (pending && Date.now() - pending.at < 300000 && pending.country === current) write('localStorage', CONFIRMED, current);
      remove('sessionStorage', PENDING);
    } catch { remove('sessionStorage', PENDING); }
    const saved = read('localStorage', CONFIRMED);
    const confirmed = valid(saved) ? saved : null;
    root.querySelectorAll('[data-toasty-country-flag]').forEach((element) => {
      if (/^[A-Z]{2}$/.test(current)) element.textContent = String.fromCodePoint(...[...current].map((letter) => 127397 + letter.charCodeAt(0)));
    });
    const open = (automatic = false) => {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      select.value = current;
      if (automatic && confirmed && valid(confirmed) && !explicitRoute) select.value = confirmed;
      touched = !automatic;
      dialog.showModal();
      select.focus({ preventScroll: true });
    };
    const close = () => { dismissed = true; write('sessionStorage', DISMISSED, '1'); dialog.close(); };
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button, select, a[href], input, [tabindex]')].filter((item) => !item.disabled && item.tabIndex >= 0 && item.getClientRects().length);
      const target = event.shiftKey ? items.at(-1) : items[0];
      const boundary = event.shiftKey ? items[0] : items.at(-1);
      if (document.activeElement === boundary || !dialog.contains(document.activeElement)) {
        event.preventDefault(); target?.focus();
      }
    });
    dialog.addEventListener('close', () => previousFocus?.focus?.({ preventScroll: true }));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    root.querySelectorAll('[data-toasty-destination-close]').forEach((button) => button.addEventListener('click', close));
    root.querySelector('[data-toasty-destination-open]')?.addEventListener('click', () => open());
    ['change', 'keydown', 'pointerdown'].forEach((event) => select.addEventListener(event, () => { touched = true; }));
    form.addEventListener('submit', (event) => {
      if (!valid(select.value)) { event.preventDefault(); select.focus(); return; }
      write('sessionStorage', PENDING, JSON.stringify({ country: select.value, at: Date.now() }));
      write('sessionStorage', DISMISSED, '1');
    });
    document.addEventListener('submit', (event) => {
      const otherForm = event.target;
      if (otherForm === form || !(otherForm instanceof HTMLFormElement)) return;
      const action = new URL(otherForm.action, location.href);
      if (action.origin !== location.origin || !/\/localization\/?$/.test(action.pathname)) return;
      const code = new FormData(otherForm).get('country_code');
      if (!valid(code)) return;
      write('sessionStorage', PENDING, JSON.stringify({ country: code, at: Date.now() }));
      write('sessionStorage', DISMISSED, '1');
    });
    window.addEventListener('pageshow', (event) => { if (event.persisted && dialog.open) close(); });
    if (root.dataset.promptEnabled !== 'true' || (confirmed && (confirmed === current || explicitRoute)) || read('sessionStorage', DISMISSED)) return;
    open(true);
    if (explicitRoute || confirmed) return;
    fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin', signal: AbortSignal.timeout(3000) })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        const code = data?.detected_values?.country?.handle;
        if (touched || dismissed || !dialog.open || !valid(code)) return;
        select.value = code;
        const suggestion = root.querySelector('[data-toasty-country-suggestion]');
        if (suggestion) suggestion.hidden = false;
      }).catch(() => {});
  };
  const initAll = () => document.querySelectorAll('[data-toasty-destination-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
